module.exports = __webpack_public_path__ + "static/media/expand-arrows.af44f67f.svg";